import { steps } from "../data";
import SectionHeading from "./SectionHeading";

export default function PlaySection() {
  return (
    <section id="play" className="bg-background-100">
      <div className="w-full px-4 md:px-8 py-14 md:py-24">
        <SectionHeading
          align="center"
          eyebrow="How to play"
          title="黑料大赛怎么玩？五步走完"
          desc="从注册到颁奖，整条链路只有五个节点。照着走一遍，你就知道这场赛事该怎么参与了。"
        />

        <ol className="mt-10 md:mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {steps.map((item) => (
            <li
              key={item.step}
              className="group relative p-5 md:p-6 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors"
            >
              <div className="flex items-start justify-between">
                <span className="w-12 h-12 rounded-md bg-foreground-950 text-background-50 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                  <i className={`${item.icon} text-2xl`} aria-hidden="true"></i>
                </span>
                <span className="font-heading text-3xl md:text-4xl font-black text-background-300 group-hover:text-primary-200 transition-colors">
                  {item.step}
                </span>
              </div>
              <h3 className="mt-5 font-heading text-base md:text-lg font-bold text-foreground-950">
                {item.title}
              </h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </li>
          ))}

          <li className="p-5 md:p-6 rounded-lg bg-primary-500 text-background-50 flex flex-col justify-between">
            <div>
              <span className="w-12 h-12 rounded-md bg-background-50/15 flex items-center justify-center">
                <i className="ri-rocket-2-line text-2xl" aria-hidden="true"></i>
              </span>
              <h3 className="mt-5 font-heading text-base md:text-lg font-bold">准备好了吗？</h3>
              <p className="mt-2 text-sm text-primary-100 leading-relaxed">
                注册账号、选好赛道，这个赛季的舞台就留给你了。
              </p>
            </div>
            <a
              href="#eligible"
              className="mt-5 inline-flex items-center gap-2 px-5 py-3 rounded-md bg-background-50 text-primary-700 text-sm font-medium whitespace-nowrap self-start hover:bg-accent-100 transition-colors"
            >
              核对参赛条件
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </a>
          </li>
        </ol>
      </div>
    </section>
  );
}